"use client";

import { format } from "date-fns";
import { Calendar as CalendarIcon } from "lucide-react";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { useState } from "react";

export function DatePicker({
  date,
  onChange,
  label = " Select delivery date",
  className,
  disabled = [],
}) {
  const [isFocused, setIsFocused] = useState(false);

  return (
    <div className={`relative mb-5 ${className}`}>
      <Popover>
        <PopoverTrigger asChild>
          <Button
            variant={"outline"}
            className={cn(
              "w-full h-[50px] px-3 py-2 border border-gray-300 rounded-[8px] text-black focus:outline-none focus:border-blue-500 mt-1 flex items-center justify-between",
              !date && "text-muted-foreground"
            )}
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
          >
            <span className={cn(date ? "" : "text-gray-500")}>
              {date ? format(date, "PPP") : ""}
            </span>
            <CalendarIcon className="h-5 w-5 text-gray-500" />
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0">
          <Calendar
            mode="single"
            selected={date}
            onSelect={(selectedDate) => {
              onChange(selectedDate);
              setIsFocused(false);
            }}
            initialFocus
            disabled={disabled}
            className=""
            showOutsideDays={false}
          />
        </PopoverContent>
      </Popover>
      <label
        className={cn(
          "absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500 transition-all duration-200 pointer-events-none  px-1 text-[14px]",
          {
            "top-[2px] text-xs text-gray-700 bg-white": isFocused || date,
          }
        )}
      >
        {label}
      </label>
    </div>
  );
}
